import './about.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight, 
  faGamepad, 
  faTrophy,
  faCheckCircle,
  faPuzzlePiece,
  faRocket,
  faBrain,
  faChartLine,
  faUsers,
  faFire
} from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';

const JocuriPresentation = () => {
  return (
    <div className="general-container-footer-info-ab">
      <div className="info-footer-container-ab">
        <section className='section-about-1'>
          <div>
            <h3 className='align-about-ab'>
              <span className='acasa-about-footer'>Acasa</span>
              <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
              <span className='color-despre'>Jocuri</span>
            </h3>
          </div>
        </section>

        <div className='tittle-ab-top'>
          <h4>Jocuri educaționale de contabilitate</h4>
        </div>

        <div className='career-hero'>
          <p className='hero-subtitle'>Învață contabilitatea jucându-te! Aplicații practice și distractive pentru consolidarea cunoștințelor</p>
          <div className='stats-career'>
            <div className='stat-item-career'>
              <FontAwesomeIcon icon={faGamepad} className='stat-icon-career' />
              <div className='stat-number-career'>15+</div>
              <div className='stat-label-career'>Jocuri interactive</div>
            </div>
            <div className='stat-item-career'>
              <FontAwesomeIcon icon={faUsers} className='stat-icon-career' />
              <div className='stat-number-career'>5,000+</div>
              <div className='stat-label-career'>Jucători activi</div>
            </div>
            <div className='stat-item-career'>
              <FontAwesomeIcon icon={faTrophy} className='stat-icon-career' />
              <div className='stat-number-career'>50,000+</div>
              <div className='stat-label-career'>Puncte câștigate</div>
            </div>
          </div>
        </div>

        <section className='section-about-2'>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faBrain} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
          </div>
          <div className='part-text-about'>
            <h4>Învățare prin joc</h4>
            <p>
              Jocurile educaționale ContaLearn transformă învățarea contabilității într-o experiență distractivă și captivantă.
            </p>
            <p>
              Prin gamification, conceptele complexe devin ușor de înțeles și memorat. Fiecare joc este conceput să întărească cunoștințele dobândite în cursuri și să te ajute să le aplici în situații practice.
            </p>
            <p>
              Câștigă puncte, urcă în clasament și primește badge-uri pe măsură ce progresezi!
            </p>
          </div>
        </section>

        <div className='section-header-career'>
          <h2>Tipuri de jocuri</h2>
          <p className='section-subtitle-career'>Alege jocul potrivit pentru a-ți testa cunoștințele</p>
        </div>

        <section className="open-roles">
          <div className="job-category">
            <div className='job-category-header'>
              <FontAwesomeIcon icon={faPuzzlePiece} className='job-icon' />
              <h3>Reguli de Funcționare</h3>
              <span className='job-badge'>Logic</span>
            </div>
            <p className='job-category-description'>
              Testează-ți cunoștințele despre regulile de funcționare ale conturilor contabile. Învață când crește și când scade fiecare tip de cont.
            </p>
            <div className='job-listings'>
              <div className='job-card'>
                <div className='job-card-header'>
                  <h4>Ce vei exersa?</h4>
                </div>
                <ul className='job-requirements'>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Identificarea tipului de cont (Activ, Pasiv, Venituri, Cheltuieli)</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Înțelegerea regulilor de debit și credit</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Calcularea soldurilor conturilor</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Aplicarea principiului partidei duble</li>
                </ul>
                <div className='job-footer'>
                  <div className='job-meta'>
                    <span><FontAwesomeIcon icon={faFire} /> 100+ niveluri</span>
                    <span><FontAwesomeIcon icon={faChartLine} /> Dificultate: Medie</span>
                  </div>
                  <Link to='/login' className='apply-button'>
                    Joacă acum
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="job-category">
            <div className='job-category-header'>
              <FontAwesomeIcon icon={faGamepad} className='job-icon' />
              <h3>Alege Contul</h3>
              <span className='job-badge' style={{background: 'linear-gradient(135deg, #ff8d23, #ff6b35)'}}>Rapiditate</span>
            </div>
            <p className='job-category-description'>
              Joc de viteză unde trebuie să identifici rapid contul corect pentru fiecare operațiune economică. Perfect pentru memorarea planului de conturi!
            </p>
            <div className='job-listings'>
              <div className='job-card'>
                <div className='job-card-header'>
                  <h4>Ce vei exersa?</h4>
                </div>
                <ul className='job-requirements'>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Recunoașterea rapidă a conturilor</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Asocierea operațiunilor cu conturile corecte</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Memorarea codurilor din planul de conturi</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Luarea deciziilor rapide și corecte</li>
                </ul>
                <div className='job-footer'>
                  <div className='job-meta'>
                    <span><FontAwesomeIcon icon={faFire} /> Cronometrat</span>
                    <span><FontAwesomeIcon icon={faChartLine} /> Dificultate: Ușoară-Medie</span>
                  </div>
                  <Link to='/login' className='apply-button'>
                    Joacă acum
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="job-category">
            <div className='job-category-header'>
              <FontAwesomeIcon icon={faRocket} className='job-icon' />
              <h3>Planul de Conturi</h3>
              <span className='job-badge job-badge-advanced'>Expert</span>
            </div>
            <p className='job-category-description'>
              Joc complex care testează cunoștințele avansate despre structura și organizarea planului de conturi general.
            </p>
            <div className='job-listings'>
              <div className='job-card'>
                <div className='job-card-header'>
                  <h4>Ce vei exersa?</h4>
                </div>
                <ul className='job-requirements'>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Structura completă a planului de conturi</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Clasificarea conturilor pe clase și categorii</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Relațiile dintre conturi</li>
                  <li><FontAwesomeIcon icon={faCheckCircle} className='req-icon' /> Aplicații practice complexe</li>
                </ul>
                <div className='job-footer'>
                  <div className='job-meta'>
                    <span><FontAwesomeIcon icon={faFire} /> Provocător</span>
                    <span><FontAwesomeIcon icon={faChartLine} /> Dificultate: Avansată</span>
                  </div>
                  <Link to='/login' className='apply-button'>
                    Joacă acum
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='section-about-2' style={{marginTop: '60px'}}>
          <div className='part-text-about'>
            <h4>Beneficiile jocurilor educaționale</h4>
            <div style={{display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '20px'}}>
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '15px'}}>
                <FontAwesomeIcon icon={faCheckCircle} style={{color: '#13b8ab', fontSize: '24px', marginTop: '2px'}} />
                <div>
                  <h5 style={{margin: '0 0 8px 0', color: '#202124'}}>Învățare activă</h5>
                  <p style={{margin: 0, color: '#666'}}>Participi direct în proces, nu doar citești teoria</p>
                </div>
              </div>
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '15px'}}>
                <FontAwesomeIcon icon={faCheckCircle} style={{color: '#13b8ab', fontSize: '24px', marginTop: '2px'}} />
                <div>
                  <h5 style={{margin: '0 0 8px 0', color: '#202124'}}>Feedback instant</h5>
                  <p style={{margin: 0, color: '#666'}}>Afli imediat dacă ai răspuns corect și de ce</p>
                </div>
              </div>
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '15px'}}>
                <FontAwesomeIcon icon={faCheckCircle} style={{color: '#13b8ab', fontSize: '24px', marginTop: '2px'}} />
                <div>
                  <h5 style={{margin: '0 0 8px 0', color: '#202124'}}>Motivație crescută</h5>
                  <p style={{margin: 0, color: '#666'}}>Sistemul de puncte și badge-uri te motivează să continui</p>
                </div>
              </div>
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '15px'}}>
                <FontAwesomeIcon icon={faCheckCircle} style={{color: '#13b8ab', fontSize: '24px', marginTop: '2px'}} />
                <div>
                  <h5 style={{margin: '0 0 8px 0', color: '#202124'}}>Repetare eficientă</h5>
                  <p style={{margin: 0, color: '#666'}}>Consolidezi cunoștințele prin practică distractivă</p>
                </div>
              </div>
            </div>
          </div>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faTrophy} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
          </div>
        </section>

        <div style={{textAlign: 'center', margin: '60px 0'}}>
          <h3 style={{fontSize: '32px', color: '#202124', marginBottom: '20px'}}>Pregătit pentru provocare?</h3>
          <p style={{fontSize: '18px', color: '#666', marginBottom: '30px'}}>Încearcă jocurile noastre și transformă învățarea într-o aventură!</p>
          <Link to='/registrer' style={{
            display: 'inline-block',
            padding: '16px 48px',
            background: 'linear-gradient(135deg, #13b8ab 0%, #0fa89a 100%)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '50px',
            fontWeight: '700',
            fontSize: '18px',
            boxShadow: '0 4px 15px rgba(19, 184, 171, 0.3)',
            transition: 'all 0.3s ease'
          }}>
            Începe să joci acum
          </Link>
        </div>
      </div>
    </div>
  );
};

export default JocuriPresentation;
